
//export  const baseURL = "http://localhost:8080";
export  const baseURL = "https://backend-nestorbikes-fly.fly.dev";
export  const appURL = "https://nestor-bikes-moutchic-loisirs.web.app";
export  const cloudRunBaseURL = "https://backend-nestorbikes-fly.fly.dev/";